/*******************************************************************************
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 *
 *  *  Copyright © 2021 Pearson Education, Inc.
 *  *  All Rights Reserved.
 *  *
 *  * NOTICE:  All information contained herein is, and remains
 *  * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 *  * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 *  * patent applications, and are protected by trade secret or copyright law.
 *  * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 *  * is strictly forbidden unless prior written permission is obtained from Pearson Education, Inc.
 ******************************************************************************/


import React, { Component } from "react";
import asyncCallHandler from '../../common/utils/asyncCallHandler'
import RenderChart from '../charts/RenderChart'
import chartConfig from '../../common/widgetConfigs/skillStrengthsAndWeaknesses';
import EDW_CONST from '../../common/constants';
import { EDWDropDown } from "../common/dropDown/DropDown";
import { ErrorData } from "../common/noData/NoData";

import { getCurrentYear, sortDesc, sortAsc, getChartHeight,ShowCompare } from '../../common/utils'
import EdwSwitchButton from '../common/edwSwitchButton/EdwSwitchButton'
import { EdwLoaderWithContainer } from '../common/edwLoaderWithContainer/EdwLoaderWithContainer'
import { ChartKey } from "../common/chartKey/ChartKey";
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-alpine.css';
import { sortByKey } from "../../common/utils"

export class SkillObjectivesStrengthsAndWeaknesses extends Component {
  constructor(props) {
    super();
    this.state = {
      objectivesChartConfig: {},
      isDataLoaded: false,
      showChart: true,
      sortValue: 'asce',
      objectivesData: [],
      assessmentList: [],
      selectedAssessments: [],
      tableIcons: Object.assign({}, chartConfig.tableIcons),
      defaultColDef: {
      },
      isApiFail: false,
      isShowCompare:ShowCompare(props.dateTaken)
    }
    this.iesToken = props.token ? props.token : '';
    this.activeAssessmentId = props.assessmentId;
    this.currentYear = getCurrentYear();
  }

  componentDidMount() {
    this.fetchSkillsObjectiveData();
    this.fetchAssessmentListToObjectives();

  }

  componentDidUpdate(prevProps) {
    if (
      this.props.groupId !== prevProps.groupId ||
      this.props.studentYear !== prevProps.studentYear
    ) {
      this.fetchSkillsObjectiveData();
    }
    this.props.updateExportData({ type: "assessment_saw", rowData: this.state.objectivesData, columnDefs: this.getTableColDefinition()});
  }



  switchView = () => {

    if (!this.state.showChart == true) {
      //chartConfigs = this.getChartProps(this.state.sortValue);
    }
    this.setState({ showChart: !this.state.showChart });

  }

  // renderWidget = () => {
  //   let chartConfigs = this.getChartProps(this.state.sortValue);
  //   this.setState({ objectivesChartConfig: chartConfigs, isDataLoaded: true});
  // }

  getObjectivesChartView = () => {
    let chartConfigToRender = Object.assign({}, this.state.objectivesChartConfig);
    return <RenderChart chartConfigs={chartConfigToRender} fusionKey={this.props.fusionKey}/>
  }

  onSortChanged = (params) => {
    let sortModel = params.api.getSortModel();
    console.log(sortModel);
    let sortedRowData = sortByKey(this.state.objectivesData, sortModel[0]["colId"]);
    this.setState({ objectivesData: sortedRowData });
  }

  getTableView = () => {
    return <div className="ag-theme-alpine" style={{
      height: '500px', width: '920px', margin: '0 auto', padding: '0px',
      position: 'relative'
    }} >
      <AgGridReact tooltipShowDelay={0}
        columnDefs={this.getTableColDefinition()}
        rowData={this.state.objectivesData}
        defaultColDef={this.state.defaultColDef}
        icons={this.state.tableIcons}
        onSortChanged={this.onSortChanged.bind(this)}
      />

    </div>
  }



  sortChart = (value) => {
    let chartConfigs = this.getChartProps(value);
    this.setState({ objectivesChartConfig: chartConfigs, sortValue: value })

  }

  addAssessmentToResult = (value) => {
    this.setState({ selectedAssessments: value }, function () {
      this.fetchSkillsObjectiveData()
    })
  }

  getGroupedBarChartData = (apiData, sortKey, chartID) => {

    let response = apiData;
    if (sortKey == 'alphabet')
      response = sortAsc(response, 'topicOrder')
    if (sortKey == 'desc')
      response = sortDesc(response, 'groupAverage')
    if (sortKey == 'asce')
      response = sortAsc(response, 'groupAverage')

    let chartDataset = [];

    let barChartConfig = Object.assign({}, chartConfig.chartConfig);
    barChartConfig['id'] = chartID

    response.map(val => {
      var question = (val.numberOfQuestion > 1) ? " questions" : " question";
      if (val.groupGrade.toLowerCase() == 'good') {
        let goodChartConfig = Object.assign({}, chartConfig.goodChartConfig);
        goodChartConfig.label = val.description
        goodChartConfig.value = val.groupAverage
        goodChartConfig.displayValue = val.numberOfQuestion + question
        chartDataset.push(goodChartConfig)
      }
      if (val.groupGrade.toLowerCase() == 'low') {
        let badChartConfig = Object.assign({}, chartConfig.badChartConfig);
        badChartConfig.label = val.description
        badChartConfig.value = val.groupAverage
        badChartConfig.displayValue = val.numberOfQuestion + question;
        chartDataset.push(badChartConfig)
      }
      if (val.groupGrade.toLowerCase() == 'average') {
        let avgChartConfig = Object.assign({}, chartConfig.avgChartConfig);
        avgChartConfig.label = val.description
        avgChartConfig.value = val.groupAverage
        avgChartConfig.displayValue = val.numberOfQuestion + question;
        chartDataset.push(avgChartConfig)
      }
    })

    barChartConfig.dataSource.data = chartDataset;
    return barChartConfig;
  }

  fetchSkillsObjectiveData = () => {
    this.setState({ isDataLoaded: false })
    let { width, height, token, categories, dataset, type, xAxisname, yAxisName, groupId, schoolId, examDate, dateTaken, studentYear, assessmentDate, studentId, courseId } = this.props;

    let assessmentIds = [this.activeAssessmentId, ...this.state.selectedAssessments].join(',');
    let skillTypeVal = EDW_CONST.OBJECTIVE;


    let apiEndPoint = `skill?skillType=${skillTypeVal}&assessmentId=${assessmentIds}&groupId=${groupId}&examDate=${dateTaken}&schoolId=${schoolId}&studentYear=${studentYear}`;

    let apiDomain = EDW_CONST.ASSESSMENT_END_POINT;

    if (studentId && assessmentDate) {
      apiEndPoint = `studentObjectiveSkillDetails?assessmentId=${assessmentIds}&groupId=${groupId}&schoolId=${schoolId}&assessmentDate=${assessmentDate}&studentId=${studentId}&courseId=${courseId}`;
      apiDomain = EDW_CONST.STUDENT_END_POINT;
    }


    asyncCallHandler(apiDomain, apiEndPoint, this.iesToken).then(res => {
      let skillsObjectiveData = this.getGroupedBarChartData(res.data, this.state.sortValue, 'skillsObjectivesChart');

      skillsObjectiveData.width = width;
      skillsObjectiveData.height = getChartHeight(res.data);

      skillsObjectiveData.dataSource.chart.xAxisname = xAxisname ? xAxisname : 'Topics <br />tested'
      skillsObjectiveData.dataSource.chart.yAxisName = yAxisName ? yAxisName : 'Percentage correct (%)'
      this.setState({ objectivesChartConfig: skillsObjectiveData, isDataLoaded: true, objectivesData: res.data });

    }).catch((error) => {
      console.log("axios error:", error);
      this.setState({ IsApiFail: true })
    });

  }

  fetchAssessmentListToObjectives = () => {
    let { groupId, schoolId, dateTaken, studentYear, userSchoolId, courseId } = this.props;
    let currentYear = this.currentYear;
    schoolId = userSchoolId ? userSchoolId : schoolId;
    asyncCallHandler(EDW_CONST.ASSESSMENT_END_POINT, `assessmentList?academicYear=${currentYear}&groupId=${groupId}&examDate=&schoolId=${schoolId}&studentYear=&courseId=${courseId}`, this.iesToken).then(data => {
      this.setState({ assessmentList: data.data });

    })
  }

  getChartProps = (sortValue) => {
    let responseData = this.state.objectivesData;

    let topicsData = this.getGroupedBarChartData(responseData, sortValue, 'skillsObjectivesChart');

    let { width, height, token, categories, dataset } = this.props;

    topicsData.width = width;
    topicsData.height = getChartHeight(this.state.objectivesData);

    topicsData.dataSource.chart.xAxisname = this.props.xAxisname ? this.props.xAxisname : 'Topics <br />tested';
    topicsData.dataSource.chart.yAxisName = this.props.yAxisName ? this.props.yAxisName : 'Group average (%)';

    return topicsData
  }

  getTableColDefinition = () => {

    let colDef = chartConfig.tableColumnDefinition;
    if (this.props.type) {
      colDef[0]['headerName'] = chartConfig.skillLables[this.props.type]
      colDef[0]['headerTooltip'] = chartConfig.skillLables[this.props.type]
    }
    return colDef;
  }

  getChartBlock = () => {

    if (!this.state.isDataLoaded && !this.state.IsApiFail)
      return <EdwLoaderWithContainer />
    else if (this.state.isDataLoaded && this.state.objectivesData.length > 0 && !this.state.IsApiFail) {
      let chartConfigToRender = Object.assign({}, this.state.objectivesChartConfig);
      return <RenderChart chartConfigs={chartConfigToRender} fusionKey={this.props.fusionKey}/>
    }
    else
      return <ErrorData />

  }

  render() {

    let switchProps = {
      leftLable: EDW_CONST.TABLE_VIEW,
      rightLable: EDW_CONST.GRAPH_VIEW,
      checked: this.state.showChart,
      handleChange: this.switchView
    }

    return (

      <div className="col">
        <div className="row">
          <div className="col-md-12">
            <span className="edw-widget-chart-title">{this.props.title ? this.props.title : chartConfig.title}</span>
          </div>
        </div>
        {(this.state.isDataLoaded && this.state.objectivesData.length > 0) &&
          <div className="row edw-widget-filter-area-adj">
            <div style={{ flex: 1, marginRight: 20 }}></div>
            <div style={{ marginRight: 20 }}>
              <label className="edw-widget-filter-lable">Order of {chartConfig.filterLables[this.props.type]}</label>
              <EDWDropDown
                items={[
                  { id: "asce", label: "Lowest to highest perfomance" },
                  { id: "desc", label: "Highest to lowest perfomance" },
                  { id: "alphabet", label: "Alphabetical" },
                ]}
                onChange={this.sortChart}
                label={`Order of ${chartConfig.filterLables[this.props.type]}`}
                value={this.state.sortValue}
              />
            </div>
            <div style={{ marginRight: 20 }}>
             {this.state.isShowCompare && 
              <div>
                <label className="edw-widget-filter-lable" >Add results from</label>
                <EDWDropDown
                  items={[
                    ...this.state.assessmentList.filter(
                      id => id.assessmentId !== this.activeAssessmentId
                    ).map(val => {
                      return { id: val.assessmentId, label: val.assessmentName };
                    })
                  ]}
                  onChange={this.addAssessmentToResult}
                  multiple
                  label="Select assessment"
                  value={this.state.selectedAssessments}
                />
                </div>
               }
            </div>
            <div> <div className="edw-switch-btn-adj"><EdwSwitchButton {...switchProps} /></div></div>
          </div>
        }

        <div className="row edw-widget-chart-area-adj">
          {this.state.showChart && <div className="edw-full-width">
            {/*{this.state.isDataLoaded ? (this.getObjectivesChartView()) : <EdwLoaderWithContainer />}*/}
            <ChartKey />
            {this.getChartBlock()}

          </div>
          }
          {!this.state.showChart && <div className="center-align">
            {this.state.isDataLoaded ? (this.getTableView()) : ''}
          </div>
          }
        </div>
      </div>


    );
  }
}


